import { render } from "./FinesPoints.vue?vue&type=template&id=30f5a4b5&scoped=true"
import script from "./FinesPoints.vue?vue&type=script&lang=js"
export * from "./FinesPoints.vue?vue&type=script&lang=js"

import "./FinesPoints.vue?vue&type=style&index=0&id=30f5a4b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f5a4b5"]])

export default __exports__